// extracted by mini-css-extract-plugin
export default {"imgdiv":"_836cd04283 _2a38425440","img":"_00385a0d99 _2bdb5403ec"};